<template>
    <div class="mt10">
        <div class="filter_row text_center  pa10">
            <table class="ucc_select_table">
              <tr>
                <th>상품명</th>
                <td>
                  <el-input v-model="title" @input="parentChange('title',title)"></el-input>
                </td>
              </tr>

                <tr>
                    <th>상품금액</th>
                    <td>
                        <el-input v-model="price" @input="parentChange('price',price)" maxLength="20"></el-input>

                    </td>
                </tr>
                        <div class="input_error" v-if="validation.hasError('price')">{{ validation.firstError('price') }}</div>
                <tr>
                    <th>충전밍글</th>
                    <td>
                        <el-input v-model="point" @input="parentChange('point',point)" maxLength="20"></el-input>
                    </td>
                </tr>
                <div class="input_error" v-if="validation.hasError('point')">{{ validation.firstError('point') }}</div>
                <tr>
                    <th>추가밍글</th>
                    <td>
                        <el-input v-model="bonus" @input="parentChange('bonus',bonus)" maxLength="20"></el-input>
                    </td>
                </tr>
                <div class="input_error" v-if="validation.hasError('bonus')">{{ validation.firstError('bonus') }}</div>
            </table>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import pointValidator from "@/mixins/validators/pointValidator";
import EventBus from "@/utils/event-bus";
export default {
    name: "PointWriteDefaultLayout",
    mixins: [pointValidator, dateMixins],
    components: {},
    inject: ['pointWriteSetData'],
    provide() {
        return {}
    },
    props: {
        pointData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {

        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        EventBus.$on('PointWriteDefaultLayoutValidator', this.checkValidator);
        if (this.hasData()) {
            this.initSetData();
        }
    },
    beforeDestroy() {
        EventBus.$off('PointWriteDefaultLayoutValidator');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.point = this.pointData.ibp_point;
            this.parentChange('point', this.point);
            this.bonus = this.pointData.ibp_point_extra;
            this.parentChange('bonus', this.bonus);
            this.price = this.pointData.i_price;
            this.parentChange('price', this.price);
            this.title = this.pointData.i_name;
            this.parentChange('title', this.title);
            this.itemKey = this.pointData.i_idx;
            this.parentChange('itemKey', this.itemKey);
        },
        parentChange(key, value) {
            this.pointWriteSetData(key, value)
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        hasData() {
            return !util.isEmpty(this.pointData);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
